!function() {
  Shopify.setSelectorByValue = function(t, e) {
    for (let n = 0, o = t.options.length; n < o; n++) {
      const o = t.options[n];
      if (e == o.value || e == o.innerHTML) return t.selectedIndex = n, n;
    }
  }, Shopify.CountryProvinceSelector = function(t, e, n) {
    this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), 
    this.provinceContainer = document.getElementById(n.hideElement || e), this.countryEl.addEventListener("change", this.countryHandler.bind(this)), 
    this.initCountry(), this.initProvince();
  }, Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      const t = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
    },
    initProvince: function() {
      const t = this.provinceEl.getAttribute("data-default");
      t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t);
    },
    countryHandler: function(t) {
      const e = this.countryEl.options[this.countryEl.selectedIndex].getAttribute("data-provinces"), n = JSON.parse(e);
      this.clearOptions(this.provinceEl), n && 0 == n.length ? this.provinceContainer.style.display = "none" : (this.setOptions(this.provinceEl, n), 
      this.provinceContainer.style.display = "");
    },
    clearOptions: function(t) {
      for (;t.firstChild; ) t.removeChild(t.firstChild);
    },
    setOptions: function(t, e) {
      let n = 0;
      for (e.length; n < e.length; n++) {
        const o = document.createElement("option");
        o.value = e[n][0], o.innerHTML = e[n][1], t.appendChild(o);
      }
    }
  }, document.querySelectorAll('[id^="AddressCountry"]').forEach((function(t) {
    var e = "AddressProvince" + t.id.split("AddressCountry")[1];
    new Shopify.CountryProvinceSelector(t.id, e, {
      hideElement: e
    });
  }));
  var t = document.querySelector("[data-address-add]"), e = document.querySelector("#AddAddress");
  t && e && t.addEventListener("click", (function(t) {
    e.classList.toggle("hidden");
  })), document.querySelectorAll("[data-edit]").forEach((function(t) {
    t.addEventListener("click", (function(e) {
      e.preventDefault();
      var n = document.querySelector("#EditAddress_" + t.dataset.edit);
      n && n.classList.toggle("hidden");
    }));
  })), document.querySelectorAll("[data-cancel]").forEach((function(t) {
    t.addEventListener("click", (function(e) {
      e.preventDefault();
      var n, o, i = document.querySelector("#EditAddress_" + t.dataset.cancel);
      i && i.classList.toggle("hidden"), n = t.dataset.cancel, (o = document.querySelector("#Address_" + n)) && setTimeout((() => o.scrollIntoView({
        behavior: "smooth",
        block: "center"
      }, 500)));
    }));
  }));
}();